import React, { memo } from 'react'
import Typography from 'transfix-ui/core/Typography'
import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'
import PopularToolsButtons from './PopularToolsButtons'

const usePopularToolsSectionStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
    background: brandColors.coolGray0,
    padding: `${theme.spacing(3)} 0px`,

    [theme.breakpoints.up('md')]: {
      padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
    },

    [theme.breakpoints.up('xl')]: {
      gap: theme.spacing(2),
      background: brandColors.white,
      padding: 0,
    },
  },
  title: {
    padding: `0px ${theme.spacing(2)}`,

    [theme.breakpoints.up('md')]: {
      padding: 0,
    },
  },
  buttons: {
    overflowX: 'scroll',
    scrollPadding: `0 ${theme.spacing(2)}`,

    [theme.breakpoints.up('md')]: {
      overflowX: 'hidden',
    },
  },
}))

export interface IPopularToolsSectionProps {
  /**
   * @default true
   */
  displayInline?: boolean
}

const PopularToolsSection = memo<IPopularToolsSectionProps>(({ displayInline = true }) => {
  const classes = usePopularToolsSectionStyles()
  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <Typography variant='h3'>Popular Tools</Typography>
      </div>
      <div className={classes.buttons}>
        <PopularToolsButtons displayInline={displayInline} />
      </div>
    </div>
  )
})

export default PopularToolsSection
